<template>
  <ProductPageLayout
    name="芊荨滚动长截图"
    :logo="logo"
    :hero-image="heroImage"
    lead="一键滚动截取长图，智能拼接、预览编辑与 OCR 识别，让截图分享更高效。"
    :feature-lines="featureLines"
    download-link="/ftp/packages/longshot/LongShotSetup.exe"
    download-file-name="LongShotSetup.exe"
    :meta-items="metaItems"
    :detailed-features="detailedFeatures"
    :other-features="otherFeatures"
    :reviews="reviews"
    features-desc="从滚动捕获到拼接编辑，截图全流程一站完成。"
    other-desc="覆盖截图全流程，从捕获到分享一站完成。"
    reviews-desc="真实反馈持续驱动滚动长截图体验优化。"
  />
</template>

<script>
import ProductPageLayout from '@/components/ProductPageLayout.vue'

export default {
  name: 'Longshot',
  components: { ProductPageLayout },
  data() {
    return {
      logo: require('@/assets/longshot/logo_48x48.png'),
      heroImage: require('@/assets/longshot/首页.png'),
      featureLines: [
        '滚动截屏 / 智能拼接 / 预览编辑 / 历史记录',
        'OCR 文字识别 / 多格式导出 / 快捷键操作'
      ],
      metaItems: [
        { icon: 'scroll-capture', label: '滚动截屏' },
        { icon: 'stitch', label: '智能拼接' },
        { icon: 'ocr', label: 'OCR 识别' }
      ],
      detailedFeatures: [
        {
          title: '滚动截屏',
          brief: '自动跟随页面滚动，完整捕获超长内容。',
          detail: '支持网页、文档、聊天窗口等场景的滚动截图，自动拼接成一张完整长图，告别手动截多张再拼图的繁琐。',
          image: require('@/assets/longshot/拼接.png')
        },
        {
          title: '智能拼接',
          brief: '重叠区域自动识别，拼接边缘自然无痕。',
          detail: '采用智能图像匹配算法，自动检测重叠区域并完成无缝拼接，即使页面滚动速度不均匀也能获得高质量长图。',
          image: require('@/assets/longshot/拼接.png')
        },
        {
          title: '预览与编辑',
          brief: '截图完成后即时预览，支持裁剪标注。',
          detail: '内置预览编辑器，可在保存前裁剪多余区域、添加标注或调整输出尺寸，确保每一张长图都符合分享需求。',
          image: require('@/assets/longshot/预览编辑.png')
        },
        {
          title: 'OCR 文字识别',
          brief: '从截图中快速提取文字，复制粘贴更方便。',
          detail: '内置 OCR 引擎，可对截图中的中英文文字进行识别，一键复制到剪贴板，文档整理和信息提取更高效。',
          image: require('@/assets/longshot/OCR识别.png')
        }
      ],
      otherFeatures: [
        { title: '历史记录', description: '自动保存截图历史，随时回溯查找。', icon: 'history' },
        { title: '快捷键操作', description: '全局快捷键触发，截图不打断工作流。', icon: 'keyboard' },
        { title: '多格式导出', description: '支持 PNG、JPG 等格式，灵活选择。', icon: 'image' },
        { title: '本地处理', description: '截图与 OCR 本地完成，数据不上传。', icon: 'lock' }
      ],
      reviews: [
        { name: '林编辑', comment: '写教程时需要截长网页，以前要拼好几张图，现在一键搞定，效率提升明显。', avatar: require('@/assets/longshot/avatar1.jpg') },
        { name: '周运营', comment: '做竞品分析经常要截完整页面，滚动截图拼接质量很高，边缘几乎看不出痕迹。', avatar: require('@/assets/longshot/avatar2.jpg') },
        { name: '吴开发', comment: 'OCR 识别准确率不错，截完代码文档直接复制文字，调试记录方便很多。', avatar: require('@/assets/longshot/avatar3.jpg') },
        { name: '陈设计', comment: '预览编辑功能实用，截完可以马上裁剪标注再发给客户，不用另开 PS。', avatar: require('@/assets/longshot/avatar4.jpeg') },
        { name: '黄产品', comment: '历史记录找之前的截图很方便，配合快捷键用起来很顺手。', avatar: require('@/assets/longshot/avatar5.jpeg') },
        { name: '赵学生', comment: '论文引用网页内容时截图+OCR 一条龙，比手动打字快太多了。', avatar: require('@/assets/longshot/avatar6.jpeg') }
      ]
    }
  }
}
</script>
